export const theme = {
	colors: {
		white: '#FFFFFF',
		lightGrey: '#dfeaff5c',
		grey: '#C0C7D6',
		darkGrey: '#737C8E',
		black: '#111111',
		success: '#8FCB81',
		error: '#CB8581',
		warning: '#E1D888',
		lightPurple: '#ECEFF7',
		blue: '#5486e9',
	},
	fontSize: {
		xl: '24px',
		l: '17px',
		m: '12px',
		s: '11px',
	},
}
